import React from 'react'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import { message, Upload } from 'antd'

const beforeUpload = (file) => {
    const isPDF = file.type === 'application/pdf' // Restrict only PDFs
    if (!isPDF) {
        message.error('You can only upload PDF files!')
    }

    const isLt2M = file.size / 1024 / 1024 < 2 // Check if file size is less than 2MB
    if (!isLt2M) {
        message.error('File must be smaller than 2MB!')
    }

    return isPDF && isLt2M // Only allow PDF and files smaller than 2MB
}

const dummyRequest = ({ onSuccess }) => {
    setTimeout(() => {
        onSuccess('ok')
    }, 1000)
}

const UploadPDF = ({ setFileUrl, onChnage, loading, setLoading }) => {
    const handleChange = (info) => {
        if (info.file.status === 'uploading') {
            setLoading(true)
            return
        }

        if (info.file.status === 'done') {
            onChnage(info)
        } else if (info.file.status === 'error') {
            message.error('Upload failed. Please try again.')
            setLoading(false)
        }
    }

    const uploadButton = (
        <button style={{ border: 0, background: 'none' }} type="button">
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div
                style={{
                    marginTop: 8,
                    marginBottom: 8,
                    fontSize: '18px',
                    fontWeight: 600,
                    color: '#747474',
                }}
            >
                Drop or select file
            </div>
            <span style={{ color: '#747474' }}>
                Drop files here or click to browse through your machine.
            </span>
        </button>
    )

    return (
        <Upload
            customRequest={dummyRequest}
            name="pdf"
            listType="picture-card" // Custom style for showing PDF upload icon
            className="pdf-uploader"
            showUploadList={false}
            accept=".pdf" // Only allow PDF file types
            beforeUpload={beforeUpload} // Restrict file type
            onChange={handleChange} // Handle change
            disabled={loading}
        >
            {uploadButton}
        </Upload>
    )
}

export default UploadPDF
